import { MimeType } from '@mitchell/react.component.ux';
export const getMimeType = (type) => {
    switch (type) {
        case 'image/jpeg':
            return MimeType.IMAGE_JPEG;
        case 'image/gif':
            return MimeType.IMAGE_GIF;
        case 'image/png':
            return MimeType.IMAGE_PNG;
        case 'image/bmp':
            return MimeType.IMAGE_BMP;
        case 'image/tiff':
            return MimeType.IMAGE_TIFF;
        case 'video/mp4':
            return MimeType.VIDEO_MP4;
        case 'video/mpeg':
            return MimeType.VIDEO_MPEG;
        case 'video/x-msvideo':
            return MimeType.VIDEO_AVI;
        case 'video/quicktime':
            return MimeType.VIDEO_MOV;
        case 'video/x-ms-wmv':
            return MimeType.VIDEO_WMV;
        case 'audio/mpeg':
            return MimeType.AUDIO_MPEG;
        case 'application/pdf':
            return MimeType.APPLICATION_PDF;
        case 'application/vnd.ms-excel':
            return MimeType.APPLICATION_MS_EXCEL;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return MimeType.APPLICATION_OPEN_OFFICE_EXCEL;
        case 'application/msword':
            return MimeType.APPLICATION_MS_WORD;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return MimeType.APPLICATION_OPEN_OFFICE_WORD;
        case 'text/plain':
            return MimeType.TEXT_PLAIN;
        case 'text/csv':
            return MimeType.TEXT_CSV;
        default:
            return MimeType.UNKNOWN;
    }
};
//# sourceMappingURL=MimeTypeUtils.js.map